var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trax-responsive-table mb-3"},[_c('div',{staticClass:"container"},_vm._l((_vm.rows),function(row,rowNum){return _c('div',{key:rowNum,staticClass:"row"},_vm._l((row),function(cell,colNum){return _c('div',{key:colNum,class:_vm.cellClass(colNum, cell),domProps:{"innerHTML":_vm._s(_vm.cellContent(cell))}})}),0)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }